import type { Recorded } from "../funnel/participant";

/**
 * ═══ QUI EST DANS LA SALLE NE REÇOIT PAS LA VIDÉO ═══ (tâche #370)
 *
 * Inscrit en présentiel, le participant est sur place : la scène est devant lui. Le
 * flux sur son téléphone ne lui apprend rien, lui coûte sa batterie et son forfait, et
 * son `autoplay` rejoue en décalé, dans la salle, ce que la sono vient de dire. Il
 * garde le module interactif — c'est pour lui qu'il existe.
 *
 * ⚠️ C'EST LA RÉPONSE ENREGISTRÉE QUI DÉCIDE, `answer === "onsite"`, et rien d'autre.
 * Pas encore répondu, à distance, représenté : la vidéo reste. Dans le doute on montre,
 * parce qu'un participant à distance privé du direct n'a plus rien à suivre.
 *
 * ⚠️ JAMAIS POUR L'ORGANISATEUR QUI CONFIGURE, même inscrit en présentiel lui-même. Il
 * ouvre cette page exprès pour régler la vidéo : masquée, il n'aurait plus rien à viser.
 * Ni dans l'aperçu de la régie, qui montre la place de la vidéo à un participant
 * quelconque, pas à l'organisateur.
 */
export function streamHidden({
  answer,
  organiser,
  preview,
}: {
  answer: Recorded["answer"];
  organiser: boolean;
  preview: boolean;
}): boolean {
  if (organiser || preview) return false;
  return answer === "onsite";
}
